// @flow

import React, { Component } from "react";
import { NavHashLink as NavLink } from "react-router-hash-link";
import ResponsiveImage from "../ResponsiveImage";
import AccordionFound from "../AccordionFound";
import TechnicalCard from "../TechnicalCard";
import "./WaterHard.scss";

export default class Header extends Component {
  constructor(props) {
    super(props);

    this.state = {
      menu: false,
    };
  }

  toggleMenu() {
    this.setState({
      menu: !this.state.menu,
    });
  }

  closeMenu() {
    this.setState({
      menu: false,
    });
  }
  scrollWithOffset = (el, offset, activeSection) => {
    const elementPosition = el.offsetTop - offset;
    console.log("Smooth scroll ", elementPosition);
    if (typeof window !== "undefined") {
      window.scroll({
        top: elementPosition,
        left: 0,
        behavior: "smooth",
      });
    }
  };
  getClosestParent(element, selector) {
    // Element.matches() polyfill
    if (!Element.prototype.matches) {
      Element.prototype.matches =
        Element.prototype.matchesSelector ||
        Element.prototype.mozMatchesSelector ||
        Element.prototype.msMatchesSelector ||
        Element.prototype.oMatchesSelector ||
        Element.prototype.webkitMatchesSelector ||
        ((s) => {
          var matches = (this.document || this.ownerDocument).querySelectorAll(
              s
            ),
            i = matches.length;
          while (--i >= 0 && matches.item(i) !== this) {}
          return i > -1;
        });
    }

    // Get the closest matching element
    for (; element && element !== document; element = element.parentNode) {
      if (element.matches(selector)) return element;
    }
    return null;
  }

  handleClick = (event, accNumber) => {
    console.log(event.target);
    let parent = this.getClosestParent(event.target, ".accordion__item");
    let activeItems = document.querySelectorAll(
      `.active-acc__item${accNumber}`
    );
    activeItems.forEach((item) =>
      item.classList.remove(`active-acc__item${accNumber}`)
    );
    parent.classList.add(`active-acc__item${accNumber}`);
  };

  showAccordion = (e, accId) => {
    if (window.location.pathname == "/fundamenty") {
      e.preventDefault();
    }
    let element = document.querySelector(`#${accId}`);
    element.classList.add("active");
  };

  showDoubleAccordion = (e, showId, accordionId) => {
    if (window.location.pathname == "/fundamenty") {
      e.preventDefault();
    }
    let showElement = document.querySelector(`#${showId}`);
    showElement.classList.add("active");

    let containers = document.querySelectorAll(".double-acc__container");
    containers.forEach((item) => item.classList.remove("active"));
    let accID = document.querySelector(`#${accordionId}`);
    accID.classList.add("active");
  };

  hideAccordion = (accId, accNumber) => {
    let element = document.querySelector(`#${accId}`);
    element.classList.remove("active");
  };

  render() {
    return (
      <React.Fragment>
        <section className="hydroisolation-water-hard">
          <div className="hydroisolation-water-hard_container container row">
            <div className="col-12">
              <img src="/img/evomer-logo-grey.png" className="logo-grey" />
              <p className="h3-red bold-header">Szybka hydroizolacja</p>
              <p className="h4-black small-bold-header">
                Przeciwwodna - ciężka
              </p>
              <p className="h5-black">Wzmocnienie powłoki siatką</p>
            </div>
          </div>
        </section>

        <section className="hydroisolation-water-hard-photos">
          <div className="net_container container row row-reverse">
            <div className="col-4 col-ml-12 photo-description">
              <div className="description-background">
                <p className="description-title">
                  <span className="big-letter">W</span>zmocnienie powłoki siatką
                </p>
                <p className="text-basic">
                  W celu dodatkowego wzmocnienia powłoki – bezpośrednio po
                  nałożeniu pierwszej warstwy Abizolu W2k przeciągnij ją pacą
                  zębatą, a następnie zatop w niej włókninę poliestrową lub
                  siatkę z włókna szklanego. Pamiętaj, aby wykonać 10 cm zakłady
                  na łączeniach siatki. Następnie zagładź powierzchnię „gładką”
                  częścią pacy. Siatka powinna być w pełni pokryta produktem.
                  Następnie wykonaj fasetę.
                </p>
                <img src="/img/abizol.png" className="product-photo" />
                <NavLink
                  smooth
                  scroll={(el) => {
                    this.scrollWithOffset(el, 100, "acc10");
                  }}
                  onClick={(e) => this.showAccordion(e, "acc10")}
                  className="button-product-info"
                  to={"/#acc10"}
                >
                  <span className="text-basic">Informacja o produkcie</span>
                </NavLink>
              </div>
            </div>
            <div id="acc10" className="col-8 col-ml-12 photo accordion-col">
              <ResponsiveImage imageName="photo11.jpg" imageClass={"picture"} />
              <div className="accordion-container">
                <div>
                  <h2 className="accordion-title">ABIZOL W 2K</h2>
                  <AccordionFound product="abizolw2k"></AccordionFound>
                  <button
                    onClick={() => this.hideAccordion("acc10", "7")}
                    className="close-btn"
                  >
                    <span className="af-icon-cross"></span>
                  </button>
                </div>
                <TechnicalCard
                  pdf={
                    "/pdf/abizol-w-2k-masa-bitumiczno-polimerowa-Karta-techniczna-produktu.pdf"
                  }
                />
              </div>
            </div>
          </div>

          <div className="second-layer-net_container container row">
            <div id="acc11" className="col-8 col-ml-12 photo accordion-col">
              <ResponsiveImage imageName="photo12.jpg" imageClass={"picture"} />
              <div className="accordion-container">
                <div>
                  <h2 className="accordion-title">ABIZOL W 2K</h2>
                  <AccordionFound product="abizolw2k"></AccordionFound>
                  <button
                    onClick={() => this.hideAccordion("acc11", "7")}
                    className="close-btn"
                  >
                    <span className="af-icon-cross"></span>
                  </button>
                </div>
                <TechnicalCard
                  pdf={
                    "/pdf/abizol-w-2k-masa-bitumiczno-polimerowa-Karta-techniczna-produktu.pdf"
                  }
                />
              </div>
            </div>
            <div className="col-4 col-ml-12 photo-description">
              <div className="description-background">
                <p className="description-title">
                  <span className="big-letter">D</span>ruga powłoka
                  hydroizolacyjna
                </p>
                <p className="text-basic">
                  Po wyschnięciu Abizolu W2k i fasety (ok. 4-5 godz.) nałóż
                  drugą warstwę metodą krzyżową.
                </p>
                <img src="/img/abizol.png" className="product-photo" />
                <NavLink
                  smooth
                  scroll={(el) => {
                    this.scrollWithOffset(el, 100, "acc11");
                  }}
                  onClick={(e) => this.showAccordion(e, "acc11")}
                  className="button-product-info"
                  to={"/#acc11"}
                >
                  <span className="text-basic">Informacja o produkcie</span>
                </NavLink>
              </div>
            </div>
          </div>

          <div className="thermoisolation-net_container container row row-reverse">
            <div className="col-4 col-ml-12 photo-description">
              <div className="description-background">
                <p className="description-title">
                  <span className="big-letter">M</span>ontaż termoizolacji
                </p>
                <p className="text-basic">
                  W celu dodatkowego wzmocnienia powłoki – bezpośrednio po
                  nałożeniu pierwszej warstwy Abizolu W2k przeciągnij ją pacą
                  zębatą, a następnie zatop w niej włókninę poliestrową lub
                  siatkę z włókna szklanego. Pamiętaj, aby wykonać 10 cm zakłady
                  na łączeniach siatki. Następnie zagładź powierzchnię „gładką”
                  częścią pacy. Siatka powinna być w pełni pokryta produktem.
                  Następnie wykonaj fasetę.
                </p>
                <img src="/img/abizol.png" className="product-photo" />

                <NavLink
                  smooth
                  scroll={(el) => {
                    this.scrollWithOffset(el, 100, "acc12");
                  }}
                  onClick={(e) => this.showAccordion(e, "acc12")}
                  className="button-product-info"
                  to={"/#acc12"}
                >
                  <span className="text-basic">Informacja o produkcie</span>
                </NavLink>
              </div>
            </div>
            <div id="acc12" className="col-8 col-ml-12 photo accordion-col">
              <ResponsiveImage imageName="photo13.jpg" imageClass={"picture"} />
              <div className="accordion-container">
                <div>
                  <h2 className="accordion-title">ABIZOL W 2K</h2>
                  <AccordionFound product="abizolw2k"></AccordionFound>
                  <button
                    onClick={() => this.hideAccordion("acc12", "7")}
                    className="close-btn"
                  >
                    <span className="af-icon-cross"></span>
                  </button>
                </div>
                <TechnicalCard
                  pdf={
                    "/pdf/abizol-w-2k-masa-bitumiczno-polimerowa-Karta-techniczna-produktu.pdf"
                  }
                />
              </div>
            </div>
          </div>
          <div className="video_container container row">
            <div className="col-12 photo">
              <iframe
                width="100%"
                height="500"
                src="https://www.youtube.com/embed/m1EUIZ-5VgE"
                frameborder="0"
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              ></iframe>
            </div>
          </div>
          <div className="advice_container container row">
            <div className="advice-background">
              <p className="advice-title">Rada fachowca</p>
              <p className="advice-text text-basic">
                W warunkach zwiększonej wilgotności i obniżonej temperatury
                rekomendujemy przyklejanie płyt termoizolacyjnych za pomocą EOS
                Klej do płyt XPS. Skróci to czas wysychania do 24 godzin.
              </p>
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/WaterHard/WaterHard.js